import { useAuthStore } from '@/stores/authStore';

const DEFAULT_PRIMARY = '#6366f1';

export interface BrandingValues {
  logoUrl: string | null;
  primaryColor: string;
  companyName: string;
}

/**
 * Returns the current company's branding values from the auth store.
 * The CSS variable injection is handled once in App.tsx via useBrandingEffect.
 */
export function useBranding(): BrandingValues {
  const company = useAuthStore((s) => s.user?.company);

  return {
    logoUrl: company?.logo_url ?? null,
    primaryColor: company?.primary_color ?? DEFAULT_PRIMARY,
    companyName: company?.name ?? 'Senseface',
  };
}

export { DEFAULT_PRIMARY };
